var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"landing",attrs:{"id":"main"}},[_c('Header'),_c('router-view'),_c('Footer'),_c('RegisterModal'),_c('LoginModal'),_c('WaitingDialog'),_c('VerifyEmailSuccess'),_c('ForgotPassword'),_c('Remove2FASuccess')],1)}
var staticRenderFns = []

export { render, staticRenderFns }